import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { Confirm } from 'react-confirm-bootstrap';
import { SplitButton, MenuItem } from 'react-bootstrap/lib';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import ErrorMessage from '../ErrorMessage';
import './FormPackList.scss';

class FormPackList extends PureComponent {
  actionFormatter = (cell, row) => (
    <div>
      <SplitButton
        title="Edit"
        key={row.id}
        id={`split-button-basic-${row.id}`}
        onClick={() => {
          this.props.history.push(
            `/${row.dealer_id}/formPacks/formPack/${row.id}`,
          );
        }}
      >
        <Confirm
          onConfirm={() => this.props.onDelete(row.id)}
          body={`Are you sure you want to delete ${row.name}?`}
          confirmText="Confirm Delete"
          title={`Deleting ${row.name}`}
        >
          <MenuItem>Delete</MenuItem>
        </Confirm>
      </SplitButton>
    </div>
  );

  templateFormatter = (cell, row) => {
    const { FormTemplates } = row;
    return (
      <div>
        {FormTemplates.map(form => (
          <div key={form.name}> {form.name} </div>
        ))}
      </div>
    );
  };

  createCustomInsertButton = dealerId => (
    <Link
      className="btn btn-primary btn-large new-btn-space"
      to={{ pathname: `/${dealerId}/formPacks/formPack/` }}
    >
      Add New
    </Link>
  );

  render() {
    const { list, error, dealer } = this.props;

    const options = {
      insertBtn: () => this.createCustomInsertButton(dealer.id),
    };

    return (
      <div className="form-pack-list-container">
        {error && <ErrorMessage error={error} />}
        <BootstrapTable
          data={list}
          options={options}
          insertRow
          striped
          hover
          pagination
          bodyContainerClass="list-body-container"
          tableStyle={{ border: 'none' }}
        >
          <TableHeaderColumn
            isKey
            dataField="name"
            dataSort
            filter={{ type: 'TextFilter', defaultValue: '' }}
          >
            Name
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="FormTemplates"
            dataFormat={this.templateFormatter}
          >
            Forms
          </TableHeaderColumn>
          <TableHeaderColumn
            dataField="button"
            columnClassName="list-action-column"
            dataFormat={this.actionFormatter}
          />
        </BootstrapTable>
      </div>
    );
  }
}

FormPackList.propTypes = {
  error: PropTypes.any,
  dealer: PropTypes.object,
  list: PropTypes.array,
  onDelete: PropTypes.func,
  history: PropTypes.object,
};

export default withRouter(FormPackList);
